/*
 * @,@Author: ,: chenxupeng.cxp@bytedance.com
 * @,@LastEditors: ,: chenxupeng.cxp@bytedance.com
 */
import Vue from 'vue';
import Router from 'vue-router';
/*
 * ipad环境判断更新
 * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断
 */
const isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
    // 删除pad/ipad
let device = /phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)
device = device ? (isiPad ? false : true) : false
const redirectPath = !device ? '/landing' : '/landingM'

Vue.use(Router);

export const constantRoutes = [{
        path: '/',
        redirect: redirectPath
    },
    // 渠道倒量
    {
        name: "landing",
        path: "/landing",
        component: () =>
            import (/* webpackChunkName: "landing" */ '@/pages/landingPC/index.vue'),
        meta: { type: 'pc' }
    },
    {
        name: "landingM",
        path: "/landingM",
        component: () =>
            import (/* webpackChunkName: "landingM" */ '@/pages/landingMobile/index.vue'),
        meta: { type: 'mobile' }
    },
    {
        name: "minigame",
        path: "/minigame",
        component: () =>
            import (/* webpackChunkName: "minigame" */ '@/pages/miniGamePC/index.vue'),
        meta: { type: 'pc' }
    },
    {
        name: "minigameM",
        path: "/minigameM",
        component: () =>
            import (/* webpackChunkName: "minigameM" */ '@/pages/miniGameMobile/index.vue'),
        meta: { type: 'mobile' }
    },
    {
        name: "role",
        path: "/role",
        component: () =>
            import (/* webpackChunkName: "role" */ '@/pages/rolePC/index.vue'),
        meta: { type: 'pc' }
    },
    {
        name: "roleM",
        path: "/roleM",
        component: () =>
            import (/* webpackChunkName: "roleM" */ '@/pages/roleMobile/index.vue'),
        meta: { type: 'mobile' }
    },
];


export const asyncRoutes = [];
export const router = new Router({
    mode: "history", //修改为history路由模式
    routes: constantRoutes,
});
// 手动输入网址重定向
router.beforeEach((to, from, next) => {
    if (device && to.meta.type !== 'mobile') {
        const path = to.path
        if (path == '/landing') {
            next({ path: '/landingM', meta: { type: 'mobile' }, query: to.query })
        } else if (path == '/minigame') {
            next({ path: '/minigameM', meta: { type: 'mobile' }, query: to.query })
        } else if (path == '/role') {
            next({ path: '/roleM', meta: { type: 'mobile' }, query: to.query })
        } else {
            next()
        }
    } else if (!device && to.meta.type !== 'pc') {
        const path = to.path
        if (path == '/landingM') {
            next({ path: '/landing', meta: { type: 'pc' }, query: to.query })
        } else if (path == '/minigameM') {
            next({ path: '/minigame', meta: { type: 'pc' }, query: to.query })
        } else if (path == '/roleM') {
            next({ path: '/role', meta: { type: 'pc' }, query: to.query })
        } else {
            next()
        }
    } else {
        next()
    }
})


export default router;

/**
 * TODO重置路由
 */
export function resetRouter() {}
